<template>
  <page-outline :title="$t('Webheader.orphan')">
    <template slot="pageContent">
      <div v-if="isSmartphoneOS" slot="fixed" class="mb-3">
        <div class="position-absolute top-44px w-100">
          <cm-messages-filter
            v-if="serviceId === services.PAYMENTS && mode === 2"
            class="researchfilter position-relative z-10"
            isPayments
            received
            filterType="group"
            :mode="this.mode"
            @extractCSV="extractCSV()"
            @applyFilter="applyFilter($event)"
            @refreshInbox="refreshInbox()"
          >
          </cm-messages-filter>
          <cm-messages-filter
            v-else
            class="researchfilter position-relative z-10"
            isPayments
            received
            filterType="list"
            :mode="this.mode"
            @extractCSV="extractCSV()"
            @applyFilter="applyFilter($event)"
            @refreshInbox="refreshInbox()"
          >
          </cm-messages-filter>
        </div>
      </div>
      <div class="listPage">
        <b-row
          class="form-group justify-content-start"
          v-if="false"
        >
          <b-col cols="1">
            <b-button
              :aria-label="$t('common.rfrsh')"
              class="btn"
              :disabled="activateSpinner"
              @click="refreshInbox()"
            >
              <i class="fa-light fa-rotate-right"></i>
              <span class="fab-label">{{ $t("common.rfrsh") }}</span>
            </b-button>
          </b-col>
          <b-col cols="1" offset-md="6">
            <b-button variant="primary"
              :disabled="activateSpinner"
              @click="extractCSV()"
            >
              <i class="fa-light fa-upload"></i>
              <span class="fab-label">{{ $t("common.extract") }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  v-if="serviceId === services.PAYMENTS && mode === 2"
                  class="researchfilter position-relative z-10"
                  isPayments received
                  filterType="group"
                  :mode="this.mode"
                  :randomId="randomId"
                  @extractCSV="extractCSV()"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="1"
                  @refreshInbox="refreshInbox()">
                </cm-messages-filter>
                <cm-messages-filter
                  v-else
                  class="researchfilter position-relative z-10"
                  isPayments received
                  filterType="list"
                  :mode="this.mode"
                  :randomId="randomId"
                  @extractCSV="extractCSV()"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="1"
                  @refreshInbox="refreshInbox()">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :class="customMobileLayoutStyle"></div>
            </div>

            <spinner v-if="activateSpinner" class="mt-3"></spinner>
            <div v-else>
              <span v-if="items.length" class="font-weight-bold">{{ $t('common.results_payments_desc') +  paginationObject.nbResultsTotal}}</span>
              <b-table
                class="mt-3 table-striped"
                relative
                responsive
                v-if="items.length"
                :key="keyTableFlux"
                :items="items"
                :fields="fields"
              >
                <template #cell(direction)="data">
                  <div class="cursor text-ellipsis">
                    <span v-if="data.value === '0'" class="direction-received">{{$t('common.rcvd')}}</span>
                    <span v-else class="direction-sent">{{$t('common.snt')}}</span>
                  </div>
                  <!-- <div v-if="data.value === 'Request'"><i class="fa-solid fa-right text-blue"></i></div>
                  <div v-else><i class="fa-solid fa-left text-success"></i></div> -->
                </template>
                <template #cell(dateTime)="data"><div class="text-ellipsis">{{ data.value | formatDateTime }}</div></template>
                <template #cell(clearing)="data"><div class="text-ellipsis" :class="getClearingTitleColor(data.value)">{{ data.value ? data.value : $t('filter.orphan.clearing.undefined') }}</div></template>
                <template #cell(msgType)="data"><div class="text-ellipsis">{{ getMessageTypeLabel(data.value) }}</div></template>
                <template #cell(flow)="data">
                  <div class="d-xl-flex align-items-center justify-content-center">
                    <span>{{ data.value }}</span>
                    <div>
                      <i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml({id: data.item.idFormatIn, type: data.value}, (data.item.msgType === '5' ? 'payment' : 'requestToPay'), 'see')"></i>
                      <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml({id: data.item.idFormatIn, type: data.value}, (data.item.msgType === '5' ? 'payment' : 'requestToPay'), 'download')"></i>
                    </div>
                  </div>
                </template>
              </b-table>
              <span v-else class="font-bold w-100 d-flex justify-content-center mt-3">{{ $t('common.no_result') }}</span>
            </div>
              <b-row class="mt-5">
              <b-col>
                <b-col cols="12">
                  <cm-pagination
                    :maxResultsByPage="paginationObject.maxResults"
                    :firstIndex="paginationObject.firstIndex"
                    :nbResultsTotal="paginationObject.nbResultsTotal"
                    :refreshEvent="paginationObject.refresh"
                  ></cm-pagination>
                </b-col>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import moment from "moment";

import PageOutline from "@/components/common/PageOutline.vue";

import MessagesFilter from "@/components/common/Filter";
import Spinner from "@/components/common/spinner.vue";
import Pagination from "@/components/common/pagination.vue";

import { errorMessageAlert } from "@/helpers/alert";
// import { loadPage } from "@/helpers/routing";
import services from "@/helpers/services";
// import { statusLabel } from "@/helpers/labels";
import { downloadFileWithDefinedHeaders } from '@/helpers/download';

export default {
  name: "OprhanFlux",
  components: {
    "cm-messages-filter": MessagesFilter,
    "spinner": Spinner,
    "page-outline": PageOutline,
    "cm-pagination": Pagination,
  },
  props: {
    direction: {
      default: "2",
      type: String,
    },
    modeFilter: {
      default: "4",
      type: String,
    },
  },
  data () {
    return {
      activateSpinner: false,
      clearingList: [],
      clearingListCreated: false,
      filterConditions: {
        messageType: '1,2,3,5'
      },
      items: [],
      keyTableFlux: false,
      mode: 4,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      scrollFlag: true,
      services: services,
      serviceId: this.$engine.user.currentService.id.toString(),
      serviceName: this.$t("common.appname"),
    };
  },
  computed: {
    canSeeSRTP () {
      if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '1' && this.$engine.rights.rightIs('rtp_orphan_consult_srtp', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_srtp', true)
      }
    },
    canSeeHRTP () {
      if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '2' && this.$engine.rights.rightIs('rtp_orphan_consult_hrtp', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
      }
    },
    canSeePSD2 () {
      if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '3' && this.$engine.rights.rightIs('rtp_orphan_consult_psd2', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_psd2', true)
      }
    },
    fields () {
      return [
        { key: "direction", label: this.$t('common.origin'), class: 'text-center' },
        { key: "dateTime", label: this.$t('common.dt'), class: "text-center" },
        { key: "clearing", label: this.$t('common.global.clearing'), class: "text-center font-weight-bold" },
        { key: "msgType", label: this.$t('common.routing.message'), class: "text-center" },
        { key: "initParty", label: this.$t('orphan.init_party'), class: "text-center word-break" },
        { key: "msgId", label: this.$t('orphan.msg_identifier'), class: "text-center word-break" },
        { key: "flow", label: this.$t('orphan.flow'), class: "text-center word-break" }
      ]
    },
    isSmartphoneOS() {
      return this.$f7.device.os === "android" || this.$f7.device.os === "ios"
    },
    customMobileLayoutStyle() {
      if (this.serviceId === services.PAYMENTS) {
        return "h-136px;"
      } else {
        return "h-90px;"
      }
    },
  },
  created() {
    this.$bus.$emit("change-mobile-header", {
      backLink: false,
      navbarInnerStyle: "justify-content:start;",
      navTitle: this.$t('Webheader.orphan'),
      returnUrl: "",
    });
    this.paginationObject["firstIndex"] = 1;
    this.paginationObject["maxResults"] = 15
    this.paginationObject["nbResultsTotal"] = 0;
    this.$engine.services.payments.filter.cleanFilterCondition()
    this.mode = parseInt(this.modeFilter, 10);
    let that = this;
    this.$engine.settings.set({ msgDirection: this.direction });

    this.clearingListCreated = false

    this.$bus.$on('language-changed', () => {
      that.fields = [
        { key: "direction", label: this.$t('common.origin'), class: 'text-center' },
        { key: "dateTime", label: this.$t('common.dt'), class: "text-center" },
        { key: "clearing", label: this.$t('common.global.clearing'), class: "text-center" },
        { key: "msgType", label: this.$t('common.routing.message'), class: "text-center" },
        { key: "initParty", label: this.$t('orphan.init_partyt'), class: "text-center word-break" },
        { key: "msgId", label: this.$t('orphan.msg_identifier'), class: "text-center word-break" },
        { key: "flow", label: this.$t('orphan.flow'), class: "text-center word-break" }
      ]
      that.onRefresh(false)
      that.pageCounter = 0
    })

    this.$bus.$off("refresh-cache-contacts");
    this.paginationObject['refresh'] = 'inbox-filtered'
    this.$bus.$off('inbox-filtered')
    this.$bus.$off('refresh-inbox-on-seen')
    this.$bus.$on('inbox-filtered', index => {
      that.onRefresh(false, index)
      that.pageCounter = 0
    })
    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false);
  },
  mounted() {
    this.$$(".infinite-scroll-preloader").remove();
    this.$bus.on("service:change", (val) => {
      this.serviceId = this.$engine.services.getServiceIdByName(val);
    });
  },
  beforeDestroy() {
    let that = this;
    that.$engine.services.payments.filter.cleanFilterCondition();
  },
  methods: {
    applyFilter (filterConditions) {
      let that = this
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }
      this.filterConditions = filterConditions
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      // if (this.canSeeSRTP && !this.canSeeHRTP && !this.canSeePSD2 && !this.isSuperAdmin) {
      //   filterConditions.standard = '1'
      // } else if (!this.canSeeSRTP && this.canSeeHRTP && !this.canSeePSD2 && !this.isSuperAdmin) {
      //   filterConditions.standard = '2'
      // } else if (!this.canSeeSRTP && !this.canSeeHRTP && this.canSeePSD2 && !this.isSuperAdmin) {
      //   filterConditions.standard = '3'
      // } else if (!this.canSeeSRTP && !this.canSeeHRTP && !this.canSeePSD2 && !this.isSuperAdmin) {
      //   filterConditions.standard = '0'
      // }
      if ([...new Set(filterConditions.messageType.split(','))].length === 4) {
        // filterConditions.messageType = ''
      }
      filterConditions.status = ''
      filterConditions.featureType = ''
      filterConditions.orphelan = '1'
      if (!filterConditions.messageType) {
        that.updateItems([])
        this.activateSpinner = false
        return
      }
      this.$engine.services.payments.messageRTP(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let orphans = {}
        that.paginationObject.nbResultsTotal = resp.data.totalPayments
        that.paginationObject.nbResults = resp.data.payments.length
        orphans = resp.data.payments
        that.updateItems(orphans)
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    extractCSV () {
      let firstLine =
      this.$t('common.origin') + ';' +
      this.$t('common.date_label') + ';' +
      this.$t('common.global.clearing') + ';' +
      this.$t('common.routing.message') + ';' +
      this.$t('orphan.init_party') + ';' +
      this.$t('requestToPay.msg_id') + ';' +
      this.$t('orphan.flow') + ';' +
      ' \r\n'

      let lines = ''
      let that = this


      this.paginationObject['firstIndex'] = 1
      let filterConditions
      if (this.filterConditions) {
        filterConditions = this.filterConditions
      } else if (Object.keys(this.$engine.services.payments.filter.getDefaultFilter()).length > 0) {
        filterConditions = this.$engine.services.payments.filter.getDefaultFilter()
      } else {
        filterConditions = this.$engine.services.payments.filter.getConditionObject()
      }
      if (!filterConditions.messageType || [...new Set(filterConditions.messageType.split(','))].length === 4) {
        filterConditions.messageType = ''
      }
      filterConditions.status = ''
      filterConditions.featureType = ''
      filterConditions.orphelan = '1'
      // if (this.canSeeSRTP) {
      //   filterConditions.standard = '1'
      // } else if (this.canSeeHRTP) {
      //   filterConditions.standard = '2'
      // } else if (this.canSeePSD2) {
      //   filterConditions.standard = '3'
      // }

      if (!filterConditions.messageType) {
        let data = firstLine
        that.$f7.hidePreloader()
        // const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let encodedData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        let linkSource = URL.createObjectURL(encodedData);
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.$t('Webheader.orphan') + '_' + today.unix() + '.csv'
        if (
        that.$f7.device.os === 'android' ||
        that.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(that, fileName, linkSource)
        } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        }
        that.$f7.alert('', this.$i18n.t('common.exprt_succ'))
        return
      }

      this.$engine.services.payments.messageRTP(
          this.direction,
          undefined,
          undefined,
          filterConditions
      ).then(resp => {
        let inboxMessagesCSV = {}
        inboxMessagesCSV = resp.data.payments

        let format = 'YYYY-MM-DD HH:mm:ss'
        for (let datas in inboxMessagesCSV) {
          let origin = inboxMessagesCSV[datas].direction === '1' ? that.$i18n.t('common.snt') : that.$i18n.t('common.rcvd')
          let receptionDate = moment(inboxMessagesCSV[datas].datetime, 'YYYY-MM-DDTHH:mm:ss').format(format)
          let clearing = inboxMessagesCSV[datas].standard
          let msgType = this.getMessageTypeLabel(inboxMessagesCSV[datas].messageType)
          let initParty = inboxMessagesCSV[datas].initParty
          let msgId = inboxMessagesCSV[datas].msgId
          let flow = inboxMessagesCSV[datas].type

          lines += origin + ';' +
          receptionDate + ';' +
          clearing + ';' +
          msgType + ';' +
          initParty + ';' +
          msgId + ';' +
          flow + '\r\n'
        }

        let data = firstLine + lines
        that.$f7.hidePreloader()
        const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.$t('Webheader.orphan') + '_' + today.unix() + '.csv'
        if (
        that.$f7.device.os === 'android' ||
        that.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(that, fileName, linkSource)
        } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        }
        that.$f7.alert('', that.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        if (error && error.response && error.response.data && error.response.data.error && error.response.data.error === 'ERR20') {
          that.$f7.alert(that.$i18n.t('errors._specific.description.ERR20', {nb: error.response.data.errorDescription}), that.$i18n.t('errors._specific.title.ERR20'))
        } else {
          errorMessageAlert(error, that)
        }
      })
    },
    getClearingTitleColor(clearing) {
      return 'clearing-color-' + clearing.toLowerCase()
    },
    getMessageTypeLabel(id) {
      return this.$t('filter.orphan.message_type.' + id)
    },
    isDataJSON (data) {
      let raw = data.substr(23)
      raw = atob(raw)
      try {
        return JSON.parse(raw)
      } catch (e) {
        return false
      }
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject["firstIndex"] = index
      this.paginationObject["nbResultsTotal"] = 0
      this.activateSpinner = true
      let filterConditions
      filterConditions = this.$engine.services.payments.filter.getConditionObject()
      // if (this.canSeeSRTP && !this.canSeeHRTP) {
      //   filterConditions.standard = '1'
      // } else if (!this.canSeeSRTP && this.canSeeHRTP) {
      //   filterConditions.standard = '2'
      // } else if (!this.canSeeSRTP && !this.canSeeHRTP && this.canSeePSD2) {
      //   filterConditions.standard = '3'
      // } else if (!this.canSeeSRTP && !this.canSeeHRTP && !this.canSeePSD2) {
      //   filterConditions.standard = '0'
      // }
      if (filterConditions.messageType && [...new Set(filterConditions.messageType.split(','))].length === 4) {
        filterConditions.messageType = ''
      }
      filterConditions.status = ''
      filterConditions.featureType = ''
      filterConditions.orphelan = '1'
      if (!this.filterConditions.messageType) {
        that.updateItems([])
        that.updateInbox([], noAttach)
        this.activateSpinner = false
        return
      }
      this.$engine.services.payments.messageRTP(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let orphans = {}
        that.paginationObject.nbResultsTotal = resp.data.totalPayments
        that.paginationObject.nbResults = resp.data.payments.length
        orphans = resp.data.payments
        that.updateItems(orphans)
        that.updateInbox(orphans, noAttach)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
      /*this.$engine.services.payments.updateStreamRTP(
          this.direction,
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        ).then(resp => {
          let requests = {}
          that.paginationObject.nbResultsTotal = resp.data.totalPayments
          that.paginationObject.nbResults = resp.data.payments.length
          requests = resp.data.payments

          that.updateItems(requests)
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
          that.activateSpinner = false
        }).catch(error => {
          that.activateSpinner = false
          errorMessageAlert(error, that)
        })*/
    },
    refreshInbox () {
      this.onRefresh()
    },
    seeXml (data, service, action) {
      let that = this
      const id = data.id
      const type = data.type ? data.type : 'Technical_Error'
      let xmlDetails = {}
      this.$engine.services.payments
        .getXml(service, type, id)
        .then((resp) => {
          if (resp.data) {
            xmlDetails = resp.data
            xmlDetails.type = type
            if (action === 'see') {
              that.$bus.emit('popup-xml-details', xmlDetails)
            } else {
              //download file
              let extension = '.xml'
              let message = that.$i18n.t('common.xml_downloaded')
              if (that.isDataJSON(resp.data.data)) {
                extension = '.json'
                message = that.$i18n.t('common.json_downloaded')
              }
              const fileName = moment().format('YYYYMMDD_hhmmss_') + type + extension
              downloadFileWithDefinedHeaders(that, fileName, resp.data.data)
              that.$f7.alert('', message)
            }
          }
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
    },
    updateInbox (orphans, noAttach = false) {
      this.inboxMessages = orphans
      if (orphans.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          // this.attachInfinit()
        }
      } else {
        // this.detachInfinit()
      }
    },
    updateItems (orphans) {
      this.items = []
      for (var i = 0; i < orphans.length; i++) {

        if (!this.clearingList.includes(orphans[i].standard)) {
          this.clearingList.push(orphans[i].standard)
        }

        let date = orphans[i].datetime

        let result = {
          id: orphans[i].id,
          idFormatIn: orphans[i].id_format_in,
          direction: orphans[i].direction,
          dateTime: date,
          clearing: orphans[i].standard ? orphans[i].standard : this.$i18n.t('filter.orphan.clearing.undefined'),
          msgType: orphans[i].messageType,
          initParty: orphans[i].initParty,
          msgId: orphans[i].msgId,
          flow: orphans[i].type
        }
        this.items.push(result)
      }
    }
  },
};
</script>
